import React, { Component } from "react";
import { matchPath } from "react-router";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as PointsActions } from "store/ducks/points";

import { Page, Breadcrumbs, Loading } from "components";

class Show extends Component {
  state = {
    data: {
      name: "",
      amount: "",
      reason: "",
      grid: [],
    },
    date: "",
    errors: {},
    loading: true,
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Pontos", to: "/points" },
      {
        name: "Listagem (Pontos - Lista de CPFs)",
        to: "/points/cpf-list",
      },
      { name: "Detalhes", to: "" },
    ],
  };

  componentDidMount() {
    const { getPointRequest } = this.props;

    getPointRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { data } = this.state;
    const { point } = this.props;

    if (oldProps.point.loading && !point.loading) {
      const cpfs_map = point.data.attributes.cpfs.map((cpf) => cpf.cpf);
      const values = {
        ...data,
        ...point.data.attributes,
        id: point.data.id,
        name:
          point.data.attributes.name !== null ? point.data.attributes.name : "",
        amount:
          point.data.attributes.number_of_points !== null
            ? point.data.attributes.number_of_points
            : "",
        reason:
          point.data.attributes.score_reason !== null
            ? point.data.attributes.score_reason
            : "",
        grid: cpfs_map !== null ? cpfs_map : [],
      };

      if (oldProps.location.state !== undefined) {
        if (oldProps.location.state.created_at !== undefined) {
          this.setState({ date: this.props.location.state.created_at });
        }
      }

      this.setState({
        data: values,
        loading: false,
      });
    }
  }

  handleGetID = () => {
    const match = matchPath(this.props.location.pathname, {
      path: "/points/cpf-list/:id/show",
    });
    return match.params.id;
  };

  handleChange = (data) => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  render() {
    const { data, breadcrumbs, loading } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        {!data.length && loading ? (
          <Loading type="page" size="x-large" />
        ) : (
          <section className="cpf-list-detailed">
            <h2>Dados atribuídos</h2>
            <div className="field-container">
              <span className="field">Quem atribuiu:</span>
              <span className="value">{data.name}</span>
            </div>

            <div className="field-container">
              <span className="field">Total de pontos entregue:</span>
              <span className="value">
                {data.cpfs.reduce((acc, curr) => {
                  if (curr.credited) {
                    return acc + curr.number_of_points;
                  }
                  return acc;
                }, 0)}
              </span>
            </div>

            <div className="field-container">
              <span className="field">Motivo da atribuição de pontos:</span>
              <span className="value">{data.reason}</span>
            </div>

            <div className="field-container">
              <span className="field">Data da atribuição:</span>
              <span className="value">
                {new Intl.DateTimeFormat("pt-BR").format(
                  new Date(data.created_at)
                )}
              </span>
            </div>

            <h2>Lista de CPFs</h2>
            <table className="cpf-table">
              <thead>
                <tr>
                  <th>CPF</th>
                  <th>Pontos</th>
                  <th>Créditado</th>
                </tr>
              </thead>
              {data.cpfs.map(({ cpf, number_of_points, credited }) => (
                <tr className="cpf-value">
                  <td>{cpf}</td>
                  <td>{number_of_points}</td>
                  <td>{credited ? "Sim" : "Não"}</td>
                </tr>
              ))}
            </table>
          </section>
        )}
      </Page>
    );
  }
}

const mapState = (state) => ({
  point: state.points.detail,
});

const mapActions = (dispatch) => bindActionCreators(PointsActions, dispatch);

export default connect(mapState, mapActions)(Show);
